import { useEffect, useState } from "react";
import { FocusTrap } from "focus-trap-react";
import Scrim from "../Scrim/Scrim";
import {
  checkFunctionalCookiesAllowed,
  checkLongLifeConsentCookie,
  checkSessionCookie,
  removeAllConsentCookies,
  removeFunctionalCookiesAllowedCookie,
  setFunctionalCookiesAllowed,
  setLongLifeConsentCookie,
  setSessionConsentCookie,
} from "../../core/cookie";
import { loadGA } from "../../core/google";

const CookieConsent = () => {
  const [needed, setNeeded] = useState(false);

  useEffect(() => {
    const longLifeConsent = checkLongLifeConsentCookie();
    const sessionConsent = checkSessionCookie();

    console.log("Long life consent?", longLifeConsent);
    console.log("Session consent?", sessionConsent);

    if (sessionConsent) {
      setNeeded(false);
      return;
    }

    if (longLifeConsent) {
      if (checkFunctionalCookiesAllowed()) {
        console.log("Functional cookies allowed");
        loadGA();
      }

      setNeeded(false);
    } else {
      setNeeded(true);
    }
  }, []);

  const onAcceptCookies = () => {
    setLongLifeConsentCookie();
    setFunctionalCookiesAllowed();
    setNeeded(false);
    loadGA();
  };

  const onRejectCookies = () => {
    removeAllConsentCookies();
    removeFunctionalCookiesAllowedCookie();
    setSessionConsentCookie();
    setNeeded(false);
  };

  if (!needed) return null; // Don't render if not needed

  return (
    <>
      <Scrim active={needed} handleClick={() => {}} />
      <FocusTrap>
        <div className="bg-white rounded-md shadow-md p-4 fixed bottom-8 right-0 m-2 lg:bottom-8 lg:right-4 z-[303]">
          <h1>We value your privacy</h1>
          <p>
            We use cookies to improve your experience and for marketing. Read
            our{" "}
            <a
              href="/terms/cookies"
              className="text-purple-800 hover:text-purple-900 cursor-pointer"
              title="cookie policy"
            >
              cookie policy
            </a>{" "}
            or{" "}
            <a
              href="/cookie-settings"
              title="manage our cookies"
              className="text-purple-800 hover:text-purple-900 cursor-pointer"
            >
              manage cookies
            </a>{" "}
            that we use.
          </p>
          <div className="flex gap-2 mt-4">
            <button
              title="Reject all cookies"
              className=" text-white bg-purple-500 border-0 py-2 px-8 focus:ring-black hover:bg-purple-600 rounded text-lg"
              onClick={onRejectCookies}
            >
              Reject all
            </button>
            <button
              autoFocus
              title="Accept all cookies"
              className=" text-white bg-purple-500 border-0 py-2 px-8 focus:ring-black hover:bg-purple-600 rounded text-lg"
              onClick={onAcceptCookies}
            >
              Accept all
            </button>
          </div>
        </div>
      </FocusTrap>
    </>
  );
};

export default CookieConsent;
